"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.delete.confirm.title': 'Eliminar Onboarding',
    'onboarding.delete.confirm.message': '¿Está seguro de que desea eliminar esta sesión de onboarding?',
};
